import { createApp, reactive } from 'petite-vue';
import { Litepicker } from 'litepicker';

const persons = Array.from({ length: 10 }, (item, index) => index + 1);
const datepicker = reactive({
	// datepickerDefault from inlineScript functions.php
	default: { ...datepickerDefault, persons },
	selected: {
		roomType:
			datepickerDefault.roomTypes.indexOf(datepickerDefault.selectedRoomtype) >= 0
				? datepickerDefault.selectedRoomtype
				: false,
		startDate: '',
		endDate: '',
		persons: false,
		booknow: false,
	},
	alert: {
		status: false,
		message: '',
		class: 'alert d-none',
	},
	visibility: {
		datepicker: false,
	},
	openLink() {
		if (this.finalUrl) {
			var hotelNetSolutionsWindow = window.open(this.finalUrl, '_blank');
			hotelNetSolutionsWindow.focus();
		} else {
			return false;
		}
	},
	toggleVisibility(key) {
		console.log(this.visibility[key]);
		this.visibility[key] = !this.visibility[key];
		this.alert.status = false;
	},
	get finalUrl() {
		const lang = document.querySelector('html').lang.split('-')[0];
		var roomType = (this.selected.roomType && this.selected?.roomType?.toLowerCase()) || 'Alle';
		// wenn alles ausgefüllt ist
		if (this.selected.startDate && this.selected.endDate && this.selected.persons) {
			console.log(this.selected.startDate, this.selected.endDate);
			console.log(this.default);
			this.alert.status = false;
			this.alert.class = 'alert d-none';
			let url = `https://onepagebooking.com/old-town-${roomType}`;
			let onePageBookingShortname = this.default.onePageBookingShortname || '';
			if (onePageBookingShortname) {
				onePageBookingShortname = `&roomType=${onePageBookingShortname.join()}&filter=true`;
			}
			console.log(onePageBookingShortname);
			if (this.selected.roomType == 'Alle' || this.selected.roomType == false) {
				url = 'https://onepagebooking.com/multiproperty/dd443ebf-151c-4670-b7be-e722d17a9655';
			}
			return `${url}?lang=${lang}&arrival=${this.selected.startDate.getDate()}.${
				this.selected.startDate.getMonth() + 1
			}.${this.selected.startDate.getFullYear()}&departure=${this.selected.endDate.getDate()}.${
				this.selected.endDate.getMonth() + 1
			}.${this.selected.endDate.getFullYear()}&adults=${this.selected.persons}${onePageBookingShortname}`;
		} else {
			// wenn nicht alles ausgefüllt ist
			console.log(this.selected.startDate, this.selected.endDate);
			this.alert.status = true;
			let url = `https://onepagebooking.com/old-town-${roomType}?lang=${lang}`;
			if (this.selected.roomType == 'Alle' || this.selected.roomType == false) {
				url = `https://onepagebooking.com/multiproperty/dd443ebf-151c-4670-b7be-e722d17a9655?lang=${lang}`;
			}
			return `${url}`;
		}
	},
});

const petite = createApp({
	datepicker,
}).mount('#app');

const picker = new Litepicker({
	element: document.getElementById('litepicker'),
	elementEnd: document.getElementById('litepickerend'),
	singleMode: false,
	lang: 'de-DE',
	format: 'DD. MMM',
	autoRefresh: true,
	delimiter: '/',
	allowRepick: true,
	firstDay: 1,
	numberOfMonths: 1,
	tooltipText: {
		one: 'Nacht',
		other: 'Nächte',
	},
	tooltipNumber: (totalDays) => {
		return totalDays - 1;
	},
	setup: (p) => {
		p.on('preselect', (date1, date2) => {
			if (date1 && date2) {
				datepicker.selected.startDate = date1.dateInstance;
				datepicker.selected.endDate = date2.dateInstance;
			}
		});
	},
});
